import React, { useContext } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import { ICONS } from '@Const/common'

const WizardBackButton = () => {
    const { wizardFlowStore } = useContext<RootStore>(StoresContext)

    const onPressed = () => {
        if (wizardFlowStore.currentIndex > 0) {
            wizardFlowStore.decrementIndex()
            wizardFlowStore.setCurrentSubIndex(0)
        }
    }

    return (
        <Button
            mainColor
            type="secondary"
            icon={ICONS.arrow_back}
            reverseIconPosition
            onClick={onPressed}
            disabled={wizardFlowStore.currentIndex === 0}
        >
            Back
        </Button>
    )
}

export default observer(WizardBackButton)
